import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {Button, Col, CustomInput} from "reactstrap";
import {Link, Redirect} from "react-router-dom";
import {Trans, useTranslation} from "react-i18next";
import get from 'lodash/get';

import {renderErrorsAsHTML} from "../../../Components/utils";
import {clearErrors} from "../../../actions/Connect";
import {chargebeeGenerateHostedPage, contactSalesRequest} from "../../../thunks/Billing";
import {CHARGEBEE_ADDON_WABA, CONTACT_SALES_REQUEST_TYPE_WABA_CONTRACT} from "../../../constants";


const WABA = (
    {
        activeShop,
        billingConfig,
        errors,
        isSendingHostedPageRequest,
        isSendingContactSalesRequest,

        clearErrors,
        chargebeeGenerateHostedPage,
        contactSalesRequest,
    }
) => {
    const {t, i18n} = useTranslation();

    const [redirectTo, setRedirectTo] = useState(undefined);

     let isIframe = false;
    try {
        isIframe = window.self !== window.top;
    } catch (e) {
        isIframe = true;
    }

    // ComponentDidMount
    useEffect(() => {
        clearErrors();
    }, []);

    if (redirectTo) {
        return <Redirect to={redirectTo}/>
    }

    const dashboardUrl = `/${activeShop.id}/dashboard`;
    const tariff = get(billingConfig, 'tariff');

    return <div className="d-flex justify-content-center align-items-center">
        <Col md="8" className="mx-auto app-login-box">
            <div className="modal-dialog w-100 mx-auto">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="app-header__logo w-100 justify-content-center">
                            <div className="logo-src"/>
                        </div>

                        <div className="h5 modal-title text-center pb-2">
                            <h4 className="my-4">
                                <div>
                                    {t('connect_card.waba.title', 'Register WhatsApp Business API')}
                                </div>
                            </h4>
                        </div>

                        <Trans t={t} i18nKey='connect_card.waba.instruction_text'>

                        </Trans>
                        <a href={t('connect_card.waba.instruction_link')}>{t('connect_card.waba.instruction_link_text')}</a>
                        <div className="text-center mt-5 mb-4">

                            <a color='primary' target={isIframe?'_top':'_blank'}
                                    className='btn-wide btn-lg font-size-md mt-3'
                                     href='https://app.chat-api.com/waba'
                            >
                                <Trans t={t} i18nKey='connect_card.waba.waba_legal_request_button'>
                                    Register your own WABA

                                </Trans>
                            </a>
                        </div>
                        <div className="text-center">
                            {renderErrorsAsHTML(errors)}
                        </div>
                    </div>
                    <div className="modal-footer d-flex justify-content-center">
                        <Link to={dashboardUrl} className="btn-lg btn btn-link">
                            {t('connect_bot.common.back_to_bot_list', 'Back to bots list')}
                        </Link>
                    </div>
                </div>
            </div>
        </Col>
    </div>;
};


const mapStateToProps = state => ({
    activeShop: state.Shops.activeShop,
    errors: state.Connect.errors,
    billingConfig: state.Billing.billingConfig,
    isSendingHostedPageRequest: state.Billing.isSendingHostedPageRequest,
    isSendingContactSalesRequest: state.Billing.isSendingContactSalesRequest,
});

const mapDispatchToProps = dispatch => ({
    clearErrors: () => dispatch(clearErrors()),
    chargebeeGenerateHostedPage: (addon, callback) => dispatch(chargebeeGenerateHostedPage(addon, callback)),
    contactSalesRequest: (request_type, callback) => dispatch(contactSalesRequest(request_type, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WABA);
